import {Field} from 'formik';

import {Stack} from '@mantine/core';

import {
    FormikRadioGroup,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';

import {ContactStatus} from '../types';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Contact'}>

                <Field
                    name='firstName'
                    label='First Name'
                    component={FormikTextInput}
                    my={'lg'}
                />

                <Field
                    name='lastName'
                    label='Last Name'
                    component={FormikTextInput}
                    my={'lg'}
                />

                <Field
                    name='email'
                    label='Email'
                    component={FormikTextInput}
                    withAsterisk
                    my={'lg'}
                />

                <Field
                    name='phone'
                    label='Phone'
                    component={FormikTextInput}
                    my={'lg'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Additional Details'}>

                <Field
                    name='company'
                    label='Company'
                    component={FormikTextInput}
                    my={'lg'}
                />

                <Field
                    name='position'
                    label='Position'
                    component={FormikTextInput}
                    my={'lg'}
                />

                <Field
                    name='notes'
                    label='Notes'
                    component={FormikTextInput}
                    my={'lg'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>
                <Field
                    name='status'
                    label='Status'
                    data={[{
                        label: 'Active',
                        value: ContactStatus.ACTIVE
                    }, {
                        label: 'Inactive',
                        value: ContactStatus.INACTIVE
                    }, {
                        label: 'Deleted',
                        value: ContactStatus.DELETED
                    }, {
                        label: 'Archived',
                        value: ContactStatus.ARCHIVED
                    }]}
                    component={FormikRadioGroup}
                />
            </PlatformFieldset>
        </Stack>
    );
};
